import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _AccountHelpDesk, _Project } from '../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';
import Select from 'react-select';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    disabled?: boolean;
}

export const SelectAccountHelpDesk = ({ idSelector, onChange, label, returnType = "ID", disabled }: Props) => {
    const _accountHelpDesk = useDataBean(_AccountHelpDesk);
    const { instance, setLista, lista } = _accountHelpDesk;
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        // _accountHelpDesk.getLista({State:1},null);
        _accountHelpDesk.instance.getAccountHelpDeskRender(1,1000,{State:1}).then(
            (resp:any)=>{
                setLista(resp.List);
            }
        )
    }, []);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDAccountHelpDesk === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDProject,
                    label: `${found.DataBeanProperties.Name}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

   

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? null : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDAccountHelpDesk,
        label: `${item.DataBeanProperties.Name}`,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Proyecto"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Seleccione ..."
                noOptionsMessage={() => "Sin coincidencias"}
                isDisabled={disabled}
            />
        </div >
    );
};
